/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SalesstatusQueryResponse } from '../../types/GetV1Salesstatus.ts'

export const getV1SalesstatusQueryKey = () => [{ url: '/v1/SalesStatus' }] as const

export type GetV1SalesstatusQueryKey = ReturnType<typeof getV1SalesstatusQueryKey>

/**
 * {@link /v1/SalesStatus}
 */
export async function getV1Salesstatus(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1SalesstatusQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/SalesStatus`,
        ...requestConfig,
    })
    return res
}

export function getV1SalesstatusQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SalesstatusQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SalesstatusQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SalesstatusQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Salesstatus(config)
        },
    })
}

/**
 * {@link /v1/SalesStatus}
 */
export function useGetV1Salesstatus<
    TData = ResponseConfig<GetV1SalesstatusQueryResponse>,
    TQueryData = ResponseConfig<GetV1SalesstatusQueryResponse>,
    TQueryKey extends QueryKey = GetV1SalesstatusQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SalesstatusQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SalesstatusQueryKey()

    const query = useQuery(
        {
            ...getV1SalesstatusQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
